import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthenticationService } from 'src/app/_services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    return this.authenticationService.isLoggedIn$.pipe(
      map((isLoggedIn: boolean) => {
        if (isLoggedIn || state.url === 'auth/login') {
          return true;
        }
        /*
         * If any guard returns a UrlTree, current navigation will be cancelled
         * and a new navigation will be kicked off to the UrlTree returned
         * from the guard
         */
        return this.router.parseUrl('/auth/sign-in');
      })
    );
  }
}
